<template>
  <ContentBlock class="bracket" key="bracket">
    <div>
      <BracketHeader :rounds="rounds" ref="header" @scroll="scrollGrid" />
      <div
        class="bracket__grid"
        ref="grids"
        @scroll="onGridScroll($event)"
        v-dragscroll
      >
        <BracketsGrid :grid-data="bracket" :rounds="rounds" />
      </div>
    </div>
  </ContentBlock>
</template>

<script>
import rangeRight from "lodash/rangeRight";
import { dragscroll } from "vue-dragscroll";
import BracketsGrid from "./BracketsGrid.vue";
import BracketHeader from "./BracketHeader.vue";
window.rangeRight = rangeRight;

export default {
  name: "BracketView",

  components: {
    BracketHeader,
    BracketsGrid
  },

  directives: {
    dragscroll
  },

  props: {
    bracket: {
      required: true
    }
  },

  computed: {
    bracketKeys() {
      return Object.keys(this.bracket).map(n => Number(n));
    },
    stage() {
      return Math.max(1, ...this.bracketKeys);
    },
    rounds() {
      return rangeRight(0, Math.log2(this.stage) + 1);
    }
  },

  methods: {
    onGridScroll(e) {
      this.$refs.header.scroll(e.currentTarget.scrollLeft);
    },

    scrollGrid(scrollLeft) {
      this.$refs.grids.scrollLeft = scrollLeft;
    }
  }
};
</script>

<style lang="scss">
.bracket {
  padding: 50px 35px 50px 50px;

  &__grid {
    max-height: 720px;
    overflow: auto;
    cursor: grab;

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: colors(palette-3);
    }

    &::-webkit-scrollbar-thumb {
      background: colors(palette-2);
    }

    &::-webkit-scrollbar-thumb:hover {
      background: colors(palette-4);
    }
  }

  @include breakpoint("lg-and-down") {
    padding-top: 30px;
  }

  @include breakpoint("md-and-down") {
    padding: 20px 15px;
  }
}
</style>
